(function () {
  function init(root) {
    var form = root.querySelector('#TaupeFloatingCurrencyForm');
    var input = root.querySelector('#TaupeFloatingCountryInput');
    var toggle = root.querySelector('[data-taupe-currency-toggle]');
    var list = root.querySelector('[data-taupe-currency-list]');
    if (!form || !input || !toggle || !list) return;

    function open() {
      list.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      root.classList.add('is-open');
    }

    function close() {
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-open');
    }

    function isOpen() {
      return !list.hidden;
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    list.querySelectorAll('.taupe-floating-currency__option').forEach(function (option) {
      option.addEventListener('click', function () {
        var value = option.getAttribute('data-value');
        if (!value) return;
        input.value = value;
        try {
          localStorage.setItem('taupe-currency-picked', '1');
        } catch (e) {}
        form.submit();
      });
    });

    document.addEventListener('click', function (event) {
      if (isOpen() && !root.contains(event.target)) {
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        close();
        toggle.focus();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-taupe-currency]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
